import { APP_ROUTES } from "../constants";

export const CareerUtil = {
  buildCareerDetail,
};

function buildCareerDetail(careerCode: string): string {
  return careerCode ? APP_ROUTES.PAGEMANAGEMENT.CAREER.DETAIL.replace(":careerCode", careerCode) : APP_ROUTES.PAGEMANAGEMENT.CAREER.BASE;
}